function getInfoMap(id_municipalite, idModuleCarte) {
    if (id_municipalite === '') return;
    var params = {
        'idModuleCarte': idModuleCarte
    };


    $.ajax({
        type: "GET",
        url: '/georole_web_2/get-info-map/' + id_municipalite + '/',
        data: params,
        async: false,
        dataType: 'JSON',
        success: function (response) {

            idMap = response.idMap; // Variable global


            $('#bool_aucune_carte_de_base').html(String(response.bool_aucune_carte_de_base))// #24579
            $('#map_carte_de_base').html('"'+String(response.map_carte_de_base)+'"')// #31806

            if (response.isLayerImportation) {
                $('#btn-admin-import').show();
            } else {
                $('#btn-admin-import').hide();
            }
            rechercheMultiple = response.isRechercheMultiple; // Variable global

            //Par défault les boutons sont invisibles
            $('label[for="nom_thematique"]').addClass("hidden");
            $('#identify_thematique').addClass("hidden");
        }
    });
    return idMap
}
